module.exports = __webpack_public_path__ + "img/icon-tri-cashpay.a6ce876b.png";